import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RedeemProductHistoryList from "../components/RedeemProductHistoryList";


const RedeemProductHistoryListPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Redeem History of Reward Products' />

                <RedeemProductHistoryList />

            </MasterLayout>
        </>
    );
};


export default RedeemProductHistoryListPage;
